import DOMPurify from "dompurify";
import ReactMarkdown from "react-markdown";

const RenderMarkdown = ({ markdownContent }) => {
  // Sanitize the Markdown content to prevent XSS attacks
  const sanitizedContent = DOMPurify.sanitize(markdownContent);

  return (
    <div style={{ textAlign: "left", wordWrap: "break-word" }}>
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => (
            <p style={{ margin: "5px 0px 0px 0px" }} {...props} /> // Elimina el margen del <p>
          ),
        }}
      >
        {sanitizedContent}
      </ReactMarkdown>
    </div>
  );
};

export default RenderMarkdown;